(function(){
  const triggerSelector='[data-open-consult-modal], .js-open-consult-modal, a[href="#consult"], button[href="#consult"]';
  let returnFocus=null;

  function shouldOpenByText(el){
    if(!el) return false;
    const text=(el.innerText||el.textContent||'').trim();
    return /(contact|consult|quote|inquiry|inquire|design)/i.test(text);
  }

  function openModal(trigger=null){
    const modal=document.getElementById('ciConsultBackdrop');
    if(!modal) return;
    const summary=modal.querySelector('[data-consult-product-summary]');
    const configuration=modal.querySelector('[name="contact[Product configuration]"]');
    const source=modal.querySelector('[name="contact[Source]"]');
    let inquirySource=source?.value || 'Product inquiry';
    if(trigger && configuration){
      const detail={configuration:''};
      trigger.dispatchEvent(new CustomEvent('consult:prepare',{bubbles:true,detail}));
      configuration.value=detail.configuration;
      inquirySource=detail.source || 'Product inquiry';
    }
    if(configuration){
      configuration.disabled=!configuration.value;
      summary.hidden=!configuration.value;
      if(source) source.value=configuration.value ? inquirySource : 'Free design consultation';
    }
    returnFocus=document.activeElement;
    modal.inert=false;
    modal.setAttribute('aria-hidden','false');
    modal.classList.add('is-open');
    document.body.classList.add('ci-modal-open');
    modal.querySelector('.ci-consult-close').focus({preventScroll:true});
  }

  function closeModal(){
    const modal=document.getElementById('ciConsultBackdrop');
    if(!modal || !modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.inert=true;
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('ci-modal-open');
    returnFocus?.focus({preventScroll:true});
  }

  function init(){
    const modal=document.getElementById('ciConsultBackdrop');
    if(!modal) return;
    modal.querySelector('.ci-consult-close').addEventListener('click',closeModal);
    modal.addEventListener('click',event=>{if(event.target===modal) closeModal();});
    document.addEventListener('keydown',event=>{
      if(!modal.classList.contains('is-open')) return;
      if(event.key==='Escape') closeModal();
      if(event.key!=='Tab') return;
      const items=[...modal.querySelectorAll('button,input:not([type="hidden"]),textarea,select,a[href]')].filter(node=>node.getClientRects().length);
      const first=items[0],last=items[items.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
    document.addEventListener('click',event=>{
      const candidate=event.target.closest('a,button');
      if(!candidate) return;
      if(candidate.closest('[data-no-consult-modal]')||candidate.hasAttribute('data-no-consult-modal')) return;
      const explicit=candidate.closest(triggerSelector);
      const isFormSubmit=candidate.tagName==='BUTTON'&&(candidate.getAttribute('type')||'submit').toLowerCase()==='submit'&&candidate.closest('form');
      const href=candidate.getAttribute('href');
      const textTrigger=!isFormSubmit&&!candidate.closest('.ci-header,.ci-mobile-panel')&&(!href||href.startsWith('#'))&&shouldOpenByText(candidate);
      if(explicit||textTrigger){event.preventDefault();openModal(candidate);}
    });
    if(modal.querySelector('[data-consult-response]')) openModal();
  }

  window.CatIdeaConsultModal={open:openModal,close:closeModal,init:init};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
